export enum Direction {
    UP = 'UP',
    DOWN = 'DOWN'
}


// WEBPACK FOOTER //
// ./common/src/main/resources/ts/core/enums/formulaire-directions.ts